import { z } from "zod";

export const caseFilterSchema = z.object({
    idUUID: z.string(),
    name: z.string(),

    caseNumber: z.string().optional().optional().nullable(),
    clientName: z.string().optional().optional().nullable(),
    caseType: z.array(z.string()).optional().nullable(),
    incidentState: z.array(z.string()).optional().nullable(),
    createdBy: z.array(z.string()).optional().nullable(),

    createdDateFrom: z.coerce.date().optional().nullable(),
    createdDateTo: z.coerce.date().optional().nullable(),
    doiFrom: z.coerce.date().optional().nullable(),
    doiTo: z.coerce.date().optional().nullable(),
    solFrom: z.coerce.date().optional().nullable(),
    solTo: z.coerce.date().optional().nullable(),
    anteLitemSentFrom: z.coerce.date().optional().nullable(),
    anteLitemSentTo: z.coerce.date().optional().nullable(),
    lbtyDemandSentFrom: z.coerce.date().optional().nullable(),
    lbtyDemandSentTo: z.coerce.date().optional().nullable(),

    primaryStatute: z.array(z.string()).optional().nullable(),
    exportFields: z.string().optional().nullable(),

    umDemandSentFrom: z.coerce.date().optional().nullable(),
    umDemandSentTo: z.coerce.date().optional().nullable(),
    erisaDateSentFrom: z.coerce.date().optional().nullable(),
    erisaDateSentTo: z.coerce.date().optional().nullable(),
    liabilityStatus: z
        .array(z.union([z.string(), z.number()]))
        .optional()
        .nullable(),
    anteLitemCase: z.array(z.string()).optional().nullable(),
    governmentEntity: z
        .array(z.union([z.string(), z.number()]))
        .optional()
        .nullable(),
    liabilityAccepted: z
        .array(z.union([z.string(), z.number()]))
        .optional()
        .nullable(),
    policyLimits: z.string().optional().nullable(),
    medpay: z.string().optional().nullable(),
    accidentReportDone: z.array(z.string()).optional().nullable(),
    pdSettled: z.array(z.string()).optional().nullable(),
    idCaseStatusUM: z.array(z.string()).optional().nullable(),
    uMUIMAccepted: z.array(z.string()).optional().nullable(),

    assignedTeam: z.array(z.string()).optional().nullable(),
    assignedToAttorney: z.array(z.string()).nullable(),
    assignedToDisbursementSpecialist: z.array(z.string()).optional().nullable(),
    assignedToIntakeSpecialist: z.array(z.string()).optional().nullable(),
    assignedToParalegal: z.array(z.string()).optional().nullable(),
    assignedToMedicalRecordsClerk: z.array(z.string()).optional().nullable(),
    financeLoan: z.string().optional().nullable(),
    attorneyFee: z.string().optional().nullable(),
    crmStatus: z.string().optional().nullable(),
    litigationSubStatus: z.string().optional().nullable(),

    idReferredByCompany: z.string().optional().nullable(),
    idReferredBy: z.string().optional().nullable(),
});
